<template>
	<div>
		<div class="title row">
			<div>
				<h1>Déclaration à la HATVP<i class="fa fa-refresh fa-spin" aria-hidden="true"></i></h1>
			</div>
			<div class="text-right">
				<div class="form-group">
					<label for="surname">Archives</label>
					<select v-model="year" v-on:change="gethatvp">
						<option v-for="(value, index) in years" v-bind:value="value">{{ value }}</option>
					</select>
					<button
						class="green-btn"
						@click="excel"
						v-bind:class="{disabled_btn: !hatvp || hatvp.length === 0}"
						v-bind:disabled="!hatvp || hatvp.length === 0">
						<i class="fa fa-download" aria-hidden="true"></i> Téléchargez
					</button>
				</div>
			</div>
		</div>
		<div class="row main-wrap">
			<div class="col-sm-10 col-md-8 col-lg-6">
				<div class="onglet">
				  <h3>Sélection du client</h3>
				</div>
				<form class="section-bg" v-on:submit="gethatvp">
					<div class="row">
						<div class="form-group col-sm-6">
							<label for="surname">Client</label>
							<select v-model="idclient" v-on:change="gethatvp">
								<option value="" selected disabled>Sélectionnez un client</option>
								<option value="all">Tous</option>
								<option v-for="client in clientWithTrashed" v-bind:value="client.id">{{ client.user.name }}</option>
							</select>
						</div>
						<div class="form-group col-sm-6" v-if="idclient !== '' && idclient !== 'all'">
							<label for="surname">Coût</label>
							<select>
								<option value="">Tous</option>
							</select>
						</div>
					</div>
				</form>
			</div>
			<div class="col-md-12">
				<table class="table table-striped table-bordered">
					<thead>
						<tr>
							<th>Client</th>
							<th>Période</th>
							<th>Auteurs</th>
							<th>Objet/Objectif poursuivi</th>
							<th>Domaine d'intervention</th>
							<th>Catégorie de responsable(s) public(s) sollicité(s)</th>
							<th>Fonction du ou des responsable(s) public(s) sollicité(s)</th>
							<th>Décision(s) publique(s) concernée(s)</th>
							<th>Type(s) d’actions conduites</th>
							<th>Coûts</th>
							<th>Temps</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="time in hatvp">
							<td>{{ time.client.user.name }}</td>
							<td>{{ time.dateclean }}</td>
							<td>{{ time.utilisateur.role }}</td>
							<td>{{ time.action_theme }}</td>
							<td>
								<template v-for="domaine_intervention in time.domaine_interventions">
									{{ domaine_intervention.name }}<br><br>
								</template>
							</td>
							<td>
								<template v-for="decideur_publique_categorie in time.decideur_publique_categorie">
									{{ decideur_publique_categorie.name }}<br><br>
								</template>
							</td>
							<td>{{ time.decideur_publique_fonction }}</td>
							<td>
								<template v-for="decision_publique in time.decision_publique">
									{{ decision_publique.name }}<br><br>
								</template>
							</td>
							<td>
								<template v-for="action_type_hatvp in time.action_type_hatvp">
									{{ action_type_hatvp.name }}<br><br>
								</template>
							</td>
							<td></td>
							<td>{{ time.temps }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from '../js/app.js';
import clients from '../js/clients.js';

export default {
    data() {
        return {
			clientWithTrashed: [],
            allClients: [],
            idclient: '',
            hatvp: null,
            year: new Date().getFullYear(),
            oldest:null,
            years:[new Date().getFullYear()],
        }
    },
    beforeCreate: function () {
        this.$nextTick(function () {
        	this.clients();
        })
	},
	mounted: function() {
		if (this.$route.params.idclient && this.$route.params.year) {
			this.idclient = this.$route.params.idclient;
			this.yeat = this.$route.params.year;
			Vue.http.post(
				'/api/reporting/hatvp',
				{
					idclient: this.idclient,
					year: this.year,
				}).then(response => {
					if (response.data.error) {
						console.log('error')
					}
					else {
						this.hatvp = response.data.data;
						this.oldest = response.data.oldest;
						if (this.years.length <= 1 && this.years[0] == new Date().getFullYear()) {
							this.year = new Date().getFullYear();
							this.years = [];
							for (var i = this.oldest; i <= this.year; i++) {
								this.years.push(i)
							}
						}
					}
				})
		}
	},
    methods: {
	    clients() {
			Vue.http.get(
				'/api/client/?section=list',
			).then(response => {
				this.allClients = _.orderBy(response.data.data, 'name')
				this.clientWithTrashed = _.orderBy(response.data.dataWithTrashed, 'name')
			})
	    },
	    gethatvp(){
	    	if( this.idclient ) {
		    	Vue.http.post(
		    		'/api/reporting/hatvp',
			    {
			        idclient: this.idclient,
			        year:this.year,
			    }).then( response => {
					if (response.data.error) {
						console.log('error')
					}
					else {
						this.hatvp = response.data.data;
						this.oldest = response.data.oldest;
						if( this.years.length <= 1 && this.years[0] == new Date().getFullYear()) {
							this.year = new Date().getFullYear();
							this.years = [];
							for( var i = this.oldest; i <= this.year; i++) {
								this.years.push(i)
							}
						}
					}
		    	})
	    	}
		},
		excel() {
			if( this.idclient ) {
				Vue.http.post(
					'api/reporting/excelhatvp',
					{
				        idclient: this.idclient,
				        year:this.year,
					}
				).then(response => {
					console.log(response);
					// footable.fooTable();
					window.open(response.body.file)
				})
			}
		},
    }
}
</script>

<style lang="scss">
   @import '../sass/app.scss';
</style>



// WEBPACK FOOTER //
// HATVP.vue?5ba8c379